import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type { Action, DataStructureCommon, Dispatch, ThunkAction } from 'types';
import type { SOVCountryState } from 'modules/insights/sov/types';

const { SOV } = API.END_POINTS;

const COUNTRIES_PROCESSING = 'sov/COUNTRIES_PROCESSING';
const COUNTRIES_LOADED = 'sov/COUNTRIES_LOADED';

const initialState = {
  countries: [],
  isLoading: false
};

const setStatus = (status: boolean): Action => ({
  type: COUNTRIES_PROCESSING,

  payload: {
    status
  }
});

const countriesLoaded = (countries: Array<DataStructureCommon>): Action => ({
  type: COUNTRIES_LOADED,

  payload: {
    countries
  }
});

export const fetchCountries = (): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setStatus(true));

  try {
    const url = SOV.getCountries();
    const response = await get(url);
    const countries = response.data || [];

    dispatch(setStatus(false));

    return dispatch(countriesLoaded(countries));
  } catch (error) {
    logError(error);
    throw error;
  } finally {
    dispatch(setStatus(false));
  }
};

const handleProcessing = (state: SOVCountryState, { status }): SOVCountryState => ({
  ...state,
  isLoading: status
});

const handleLoaded = (state: SOVCountryState, { countries }): SOVCountryState => ({
  ...state,
  countries,
  isLoading: false
});

export default createReducer<any, any>('sovCountries', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [COUNTRIES_PROCESSING]: handleProcessing,
  [COUNTRIES_LOADED]: handleLoaded
});
